import { render, staticRenderFns } from "./FrequenciesListCard.vue?vue&type=template&id=f28a5574&"
import script from "./FrequenciesListCard.vue?vue&type=script&lang=js&"
export * from "./FrequenciesListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports